import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'fabric.editor.ai.config.item.addIntroduction.title',
		defaultMessage: 'Add introduction',
		description:
			'Describes an option to use Atlassian Intelligence to write an introduction based on the content currently selected by the user',
	},
	description: {
		id: 'fabric.editor.ai.config.item.addIntroduction.description',
		defaultMessage: 'Writes an introduction for you based on the given content',
		description: 'Description for the the Atlassian Intelligence "Add introduction".',
	},
});
